// @flow
import * as React from 'react';

import { StyledCSSTransition, StyledTransitionGroup, TRANSITION_DURATION_TOTAL } from './styles';

type Props = {
    children: React.Element<any>,
    childKey: string,
    isSwitchable?: boolean
};

/**
 * Allows the user to see a "flip" transition between two different bits of content.
 *
 * Requires that the supplied children have a `key`.
 */
export default function Flipper({ children, childKey, isSwitchable = true }: Props) {
    return (
        <StyledTransitionGroup isSwitchable={isSwitchable}>
            <StyledCSSTransition classNames="flipper__flip" key={childKey} timeout={TRANSITION_DURATION_TOTAL}>
                {children}
            </StyledCSSTransition>
        </StyledTransitionGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/index.js